export const userProfileToAccountType = (userProfile) => userProfile && userProfile.get("classification4");
